/* src/app/common/components/restaurant-upsertion/restaurant-upsertion.component.scss */
.template-selection-link,
.template-selection-link.ion-activatable:hover {
  --color-hover: var(--ion-color-primary);
  color: var(--ion-color-primary);
}
.template-selection-link ion-icon {
  margin-right: 12px;
}
.template-selection-link ion-label {
  max-width: unset;
  overflow: visible;
}
.template-selection-link .indicator {
  position: absolute;
  right: 9px;
  top: 12px;
  z-index: 2;
  background-color: var(--ion-color-success);
  width: 12px;
  height: 12px;
  border-radius: 50%;
}
.selection-name {
  flex-grow: 0;
  flex-basis: unset;
}
.form-theme {
  --ion-background-color: #f9fdf9;
}
.form-card {
  border-radius: 16px;
  box-shadow: 0 2px 8px rgba(0, 128, 0, 0.05);
  margin-bottom: 16px;
}
.form-card-header {
  background:
    linear-gradient(
      90deg,
      #d9f2d9,
      #f9fdf9);
  border-bottom: 1px solid #e0f2e9;
}
.form-card-content {
  padding: 4px;
}
ion-radio-group {
  display: block;
  padding-top: 5px;
  padding-bottom: 10px;
}
ion-card-title {
  font-size: 1rem;
  font-weight: 600;
  color: #2e7d32;
}
.form-item {
  --inner-padding-end: 0;
  margin-bottom: 12px;
  border-radius: 12px;
  --background: #ffffff;
  box-shadow: 0 1px 4px rgba(0, 128, 0, 0.08);
}
ion-label {
  font-size: 0.9rem;
  font-weight: 500;
  color: #000;
}
ion-input,
ion-textarea,
ion-select {
  --placeholder-color: #9e9e9e;
  font-size: 0.9rem;
}
.btn-modern {
  --background: #2e7d32;
  --color: #fff;
  border-radius: 12px;
  padding: 0 16px;
  font-weight: 600;
}
.btn-modern-outline {
  --background: transparent;
  --color: #2e7d32;
  border: 1px solid #2e7d32;
  border-radius: 12px;
  padding: 0 16px;
  font-weight: 600;
}
.sub-text-label {
  color: #000;
  font-size: 0.8em;
  font-weight: 400;
  margin-top: -10px;
}
/*# sourceMappingURL=restaurant-upsertion.component.css.map */
